import { autobind } from 'core-decorators';
import { computed, observable, action } from 'mobx';

@autobind
export default class __GenericAuthStore {
  /**
   * @type {'daily'|'wechat'|'qq'|'weibo'|'h5'} ua - 当前 userAgent
   */
  @observable ua;
  /**
   * @type {'success'|'error'|'logout'} status - 登录转台
   */
  @observable status;
  /**
   * @type {object} data - 授权数据, 可以是成功或是失败的授权数据
   * e.g.
   * {
   *    "code": -20101,
   *    "data": {
   *      "request_id": "d53aa2f39d9d0199601c35bd93a7587dee47fcad"
   *    },
   *    "status": -20101,
   *    "msg": "请先登录",
   *    "message": "请先登录",
   *    "reason": "require-login"
   *  }
   */
  @observable data;

  /**
   * 是否已经登录
   * @returns {boolean}
   */
  @computed
  get hasLogin() {
    return this.status === 'success';
  }

  /**
   * 是否已经登出
   * @returns {boolean}
   */
  @computed
  get hasLogout() {
    return !this.hasLogin;
  }

  /**
   * 获取用户名
   * 如: xsj******001
   * @returns {boolean|*}
   */
  @computed
  get username() {
    return this.hasLogin ? this.data.account : '';
  }

  /**
   * 是否有登录错误
   * @returns {boolean}
   */
  @computed
  get hasLoginError() {
    return this.status === 'error';
  }

  constructor({ globalAuthName }) {
    // noinspection JSUnresolvedVariable
    if (window[globalAuthName]) {
      const { ua, status, data } = window[globalAuthName];
      this.ua = ua;
      this.status = status;
      if (status === 'success') {
        this.data = data;
      } else {
        this.data = data;
      }
    }
  }

  /**
   * 登录
   * @param {'daily'|'wechat'|'qq'|'weibo'|'h5'} [type] - 当前 userAgent
   * @param {'success'|'error'|'logout'} [status] - 登录转台
   * @param {object} [data] - 授权数据, 可以是成功或是失败的授权数据
   */
  @action
  login({ type, status, data }) {
    this.status = 'success';
    type && (this.ua = type);
    data && (this.data = data);
  }

  /**
   * 登出
   */
  @action
  logout() {
    this.status = 'logout';
    this.data = null;
  }
}
